import { Alignment } from "@ckeditor/ckeditor5-alignment";
import { ClassicEditor } from "@ckeditor/ckeditor5-editor-classic";

import { Bold, Italic, Underline } from "@ckeditor/ckeditor5-basic-styles";
import { Heading } from "@ckeditor/ckeditor5-heading";
import {
  FontColor,
  FontBackgroundColor,
  FontFamily,
  FontSize,
} from "@ckeditor/ckeditor5-font";
import { Link } from "@ckeditor/ckeditor5-link";
import { Undo } from "@ckeditor/ckeditor5-undo";
import { HorizontalLine } from "@ckeditor/ckeditor5-horizontal-line";

import {
  Image,
  ImageToolbar,
  ImageUpload,
  ImageInsert,
  ImageResize,
  ImageResizeEditing,
  ImageResizeHandles,
} from "@ckeditor/ckeditor5-image";
import MyUploadAdapter from "./MyUploadAdapter";
import { Table, TableToolbar } from "@ckeditor/ckeditor5-table";

class Editor extends ClassicEditor {
  public static override builtinPlugins = [
    Heading,
    Bold,
    Italic,
    Underline,
    Link,
    Undo,
    FontColor,
    FontBackgroundColor,
    FontSize,
    FontFamily,
    HorizontalLine,

    // IMAGE
    Image,
    ImageToolbar,
    ImageUpload,
    ImageInsert,
    ImageResize,
    ImageResizeEditing,
    ImageResizeHandles,
    Alignment,
    Table,
    TableToolbar,
  ];

  public static override defaultConfig = {
    toolbar: {
      items: [
        "heading",
        "|",
        "bold",
        "italic",
        "underline",
        "link",
        "|",
        "fontColor",
        "fontBackgroundColor",
        "fontSize",
        "fontFamily",
        "|",
        "imageUpload",
        "imageInsert",
        "alignment",
        "undo",
        "redo",
        "|",
        "insertTable",
      ],
    },

    language: "vi",

    image: {
      resizeUnit: "%" as const, // ✔ đúng kiểu
      resizeOptions: [
        {
          name: "resizeImage:original",
          label: "100%",
          value: null,
        },
        {
          name: "resizeImage:50",
          label: "50%",
          value: "50",
        },
        {
          name: "resizeImage:30",
          label: "30%",
          value: "30",
        },
      ],
      toolbar: [
        "imageStyle:inline",
        "imageStyle:block",
        "imageStyle:side",
        "|",
        "imageTextAlternative",
        "|",
        "resizeImage",
      ],
      table: {
        defaultProperties: {
          borderWidth: "0",
          borderStyle: "none",
          borderColor: "transparent",
        },
      },
    },
  };
  static override create(element: HTMLElement, config: any) {
    return super.create(element, config).then((editor: any) => {
      // Gắn custom upload adapter
      editor.plugins.get("FileRepository").createUploadAdapter = (
        loader: any
      ) => {
        return new MyUploadAdapter(loader);
      };

      return editor;
    });
  }
}

export default Editor;
